import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView } from 'model/state';
import { Dispatch } from 'redux';
import { ParentSelector } from 'components';
import { selectUserLocations, selectUserId } from 'selectors';
import { Location, LocationType } from 'model';
import { fetchUserLocations } from 'actions';

type SelectedValues = {
  userLocations: ListView<Location>,
  userId?: string | null,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  userLocations: selectUserLocations(),
  userId: selectUserId(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUserLocations: (userId: string, types: LocationType[], page: number, search?: string) => dispatch(fetchUserLocations(userId, types, page, search, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParentSelector);
